import { useState, useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import PageHero from '../../components/feature/PageHero';
import PostCard from './components/PostCard';
import { supabase } from '@/lib/supabase';
import { BlogPost } from '@/types/blog';

export default function BlogPage() {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      const { data } = await supabase
        .from('blog_posts')
        .select('*')
        .eq('publicado', true)
        .order('data_publicacao', { ascending: false });
      if (data) setPosts(data as BlogPost[]);
      setLoading(false);
    };
    fetchPosts();
  }, []);

  return (
    <main className="font-sans">
      <Header />
      <PageHero
        tag="Conteúdo jurídico"
        titulo="Blog"
        tituloItalico="Jurídico"
        subtitulo="Artigos, análises e orientações jurídicas elaborados pelos advogados do escritório Moreira Tófoli para ajudar você a tomar decisões mais seguras."
      />

      <section className="py-[60px] bg-[#F8F5EE]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between mb-12">
            <div>
              <div className="flex items-center gap-3 mb-2">
                <span className="h-px w-8 bg-[#B39B62]"></span>
                <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase">
                  Publicações recentes
                </span>
              </div>
              <h2 className="font-serif text-2xl text-[#0A1829] font-light">
                {loading ? 'Carregando...' : `${posts.length} artigo${posts.length !== 1 ? 's' : ''} disponível${posts.length !== 1 ? 'is' : ''}`}
              </h2>
            </div>
          </div>

          {loading ? (
            <div className="flex items-center justify-center py-20">
              <div className="flex items-center gap-3 text-[#0A1829]/40">
                <i className="ri-loader-4-line animate-spin text-xl"></i>
                <span className="font-sans text-sm">Carregando artigos...</span>
              </div>
            </div>
          ) : posts.length === 0 ? (
            <div className="text-center py-20">
              <p className="font-serif text-xl text-[#0A1829]/50 font-light">Nenhum artigo publicado ainda.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {posts.map((post) => (
                <PostCard key={post.id} post={post} />
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </main>
  );
}
